import { render, staticRenderFns } from "./auto_market_official.vue?vue&type=template&id=0bbf07a4&scoped=true"
import script from "./auto_market_official.vue?vue&type=script&lang=js"
export * from "./auto_market_official.vue?vue&type=script&lang=js"
import style0 from "./auto_market_official.vue?vue&type=style&index=0&id=0bbf07a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbf07a4",
  null
  
)

export default component.exports